import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[formErrorInput]'
})
export class FormErrorInputDirective implements OnInit {
    _hasInputError: boolean;
    get hasInputError(): boolean {
        return this._hasInputError;
    }
    @Input() set hasInputError(value: boolean) {
        this._hasInputError = value;
        this.applyStyle();
    }
    private isCustomComboBoxControl: boolean;

    constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

    ngOnInit() {
        this.isCustomComboBoxControl = this.elementRef.nativeElement.localName === 'res-custom-combo-box';
    }

    applyStyle() {
        let htmlControl;
        if (this.isCustomComboBoxControl) {
            //get input element from custom combo box
            htmlControl = this.elementRef.nativeElement.firstChild?.firstChild?.firstChild?.firstChild;
        } else {
            htmlControl = this.elementRef.nativeElement;
            if (this.elementRef.nativeElement?.localName === 'res-custom-combo-box') {
                htmlControl = this.elementRef.nativeElement.firstChild?.firstChild?.firstChild?.firstChild;
            }
        }
        if (htmlControl) {
            if (this.hasInputError) {
                this.renderer.addClass(htmlControl, 'form-error');
            } else {
                this.renderer.removeClass(htmlControl, 'form-error');
            }
        }
    }
}